import { render, staticRenderFns } from "./FirstName.vue?vue&type=template&id=2a66a234&scoped=true&"
import script from "./FirstName.vue?vue&type=script&lang=js&"
export * from "./FirstName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a66a234",
  null
  
)

export default component.exports